import { Injectable } from '@angular/core';

export interface CachedCommentDraft {
  context: string;
  identifier: number;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class CommentDraftCacheService {
  private storageKey = 'cachedCommentForAfterAuthentication';

  setCachedCommentDraftForAfterAuthentication(
    context: string,
    identifier: number,
    message: string
  ): void {
    localStorage.setItem(
      this.storageKey,
      JSON.stringify([context, identifier, message])
    );
  }

  getCachedCommentDraftForAfterAuthentication(): CachedCommentDraft | undefined {
    const cachedDraft = localStorage.getItem(this.storageKey);
    if (!cachedDraft) {
      return undefined;
    }

    localStorage.removeItem(this.storageKey);
    const [context, identifier, message] = JSON.parse(cachedDraft);

    return {
      context,
      identifier,
      message,
    };
  }
}
